const crypto = require("crypto");

const jwt = {
    encodeBase64(str){
        return Buffer.from(str).toString("base64");
    },
    decodeBase64(str){
        return Buffer.from(str,"base64").toString();

    },
     //编码
    encode(payload,secret){
        let header = { "typ": "JWT", "alg": "HS256" };
        let data = JSON.parse(JSON.stringify(payload));
        if (data.Msg) {
            data.Msg=""
        }
        let headerBase64 = this.encodeBase64(JSON.stringify(header));
        let payloadBase64 = this.encodeBase64(JSON.stringify(data));
        // console.log([headerBase64, payloadBase64].join("."))
        // console.log(this.sign([headerBase64, payloadBase64].join("."), 'test'),'secret')
        let sign = this.sign([headerBase64, payloadBase64].join("."), secret);
        return [headerBase64,payloadBase64,sign].join(".");
    },
    //解码
    decode(token,secret){
        let [header, payload, sign] = token.split(".");
        console.log(payload)
        console.log
        return JSON.parse(this.decodeBase64(payload));
    },
    sign(str, secret) {
        // console.log(str)
        // console.log(secret)
        // console.log(crypto.createHmac("sha256",secret).update(str).digest(""))
        return crypto.createHmac("sha256",secret).update(str).digest("base64");
    }
}

let payload = {username:"aaa"};
let secret = "secret";
// let token = jwt.encode(payload,secret);

// console.log(token);

// payload = jwt.decode(token,secret);
// console.log(payload);
export default jwt;